import { render, staticRenderFns } from "./devicedetail.vue?vue&type=template&id=25857406&scoped=true"
import script from "./devicedetail.vue?vue&type=script&lang=js"
export * from "./devicedetail.vue?vue&type=script&lang=js"
import style0 from "./devicedetail.vue?vue&type=style&index=0&id=25857406&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25857406",
  null
  
)

export default component.exports